import {
	Breakpoints,
	Container,
	ContainerPadding,
	Layout,
	Text,
	TokenTextAppearance,
	TokenTextColor,
	Image,
	ThemeProvider,
	CTA,
} from '@volkswagen-onehub/components-core';
import * as React from 'react';
import styled from 'styled-components';
import { Environment } from '../enviroment';
import { createNavigationCta } from '../helpers/cta-helpers';
import { MastersContext } from '../context/masters-context';
import { clubStatus, GetPersonUser } from '@esportal/portal-service';
import { ResponsiveText } from '../components/responsive-text';

const FooterSection = styled.div`
	background: var(--Primary-blue600, #001e50);
	padding-left: var(--size-grid002);
	padding-top: var(--size-dynamic0270);
	padding-bottom: var(--size-dynamic0270);
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: var(--size-dynamic0200);

	@media screen and (min-width: 960px) {
		flex-direction: row;
		align-items: center;
	}
`;

const Button = styled.div`
	display: flex;
	justify-content: flex-start;
	flex-wrap: wrap;
`;

const CopyContainer = styled(Container)`
	width: 100%;
	padding-right: var(--size-grid002);

	@media screen and (min-width: 960px) {
		width: var(--size-grid010);
		padding-right: 0px;
	}
`;

const ImageContainer = styled(Container)`
	width: 100%;
	display: flex;
	justify-content: center;

	img {
		display: block;
		width: 100%;
		height: auto;
	}

	@media screen and (min-width: 960px) {
		width: var(--size-grid010);
		margin-left: auto;
		justify-content: flex-end;
	}
`;

const StyledVW = styled(Text)`
	line-height: 90%;
`;

export const Footer = ({ userData }: { userData: GetPersonUser | null }): React.ReactElement => {
	const { navigationService } = React.useContext(MastersContext);
	const navigationCta = createNavigationCta(navigationService);

	return (
		<Layout
			data-testid="driving_experience__layout"
			appearance={{
				[Breakpoints.default]: [
					{ name: '.', columns: 0 },
					{ name: 'a', columns: 24 },
					{ name: '.', columns: 0 },
				],
			}}
			allowOverflowingContent
		>
			<FooterSection className="footer-section">
				<CopyContainer wrap={'always'}>
					<Container padding={{ bottom: ContainerPadding.dynamic0050 }}>
						<StyledVW appearance={TokenTextAppearance.headline500} color={TokenTextColor.inverted}>
							<b>Club</b> <br /> Volkswagen
						</StyledVW>
					</Container>
					<Text appearance={TokenTextAppearance.headline200} color={TokenTextColor.inverted} bold>
						Conducir es solo el principio
					</Text>
					<Container padding={{ bottom: ContainerPadding.dynamic0130, top: ContainerPadding.dynamic0050 }}>
						<ResponsiveText
							appearance={{
								[Breakpoints.default]: TokenTextAppearance.copy200,
								[Breakpoints.b1920]: TokenTextAppearance.bigcopy100,
							}}
							color={TokenTextColor.inverted}
						>
							Disfruta las experiencias únicas y beneficios exclusivos que tiene el club para ti.{' '}
							<b>¿Lo mejor? Formar parte no cuesta nada y a cambio disfrutas todo.</b>
						</ResponsiveText>
					</Container>
					<Button>
						{userData?.portalUser.data.clubVW.status == clubStatus.MEMBER ? (
							<ThemeProvider theme={'inverted'}>
								<CTA
									tag="button"
									aria-label="Descubre todas las ventajas"
									onClick={() => navigationCta(Environment.getInstance().portal)}
								>
									Descubre todas las ventajas
								</CTA>
							</ThemeProvider>
						) : (
							<ThemeProvider theme={'inverted'}>
								<CTA
									tag="button"
									aria-label="Descubre todas las ventajas"
									onClick={() => navigationCta(Environment.getInstance().beneficios)}
								>
									Descubre todas las ventajas
								</CTA>
							</ThemeProvider>
						)}
					</Button>
				</CopyContainer>
				<ImageContainer>
					<Image
						src="https://assets.volkswagen.com/is/image/volkswagenag/footer_img?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMjU2JmZtdD1wbmctYWxwaGEmYmZjPW9mZiZlY2M4"
						alt="Club Volkswagen"
					/>
				</ImageContainer>
			</FooterSection>
		</Layout>
	);
};
